import { LocalDate } from '../../../utilities/local-date';
import type { EmployeeForStaffingCalendar } from './employee-for-staffing-calendar';
import type { WorkSchedule } from '@trinnvis/dabih-api-client';
import { orderBy } from 'lodash';
import { defaultWorkSchedule } from './default-work-schedule';

/**
 * Returns current schedule (or default schedule)
 */
export function getCurrentSchedule(day: LocalDate, employee: EmployeeForStaffingCalendar): WorkSchedule {
  const schedules = orderBy(employee.workSchedules, [(e) => e.start], ['desc']);
  let currentSchedule: WorkSchedule = defaultWorkSchedule;
  for (const item of schedules) {
    if (!item.start || LocalDate.fromString(item.start).isSameOrBefore(day)) {
      currentSchedule = item;
      break;
    }
  }
  if (employee.uuid === '47f37665-7d88-4932-8d71-6f629f0674de') {
    console.log(day.toString(), currentSchedule, employee);
  }
  return currentSchedule;
}
